import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bToMb',
  standalone: true,
})
export class ByteToMegaBytePipe implements PipeTransform {
  public transform(value: number): number {
    return Math.round((value / 1024 / 1024) * 100) / 100;
  }
}
